import { useState, useEffect, useCallback } from "react";
import API from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Flag } from "lucide-react";
import { toast } from "sonner";

export const ModerationQueueWidget = () => {
  const [reports, setReports] = useState([]);

  const load = useCallback(async () => {
    try { setReports((await API.get("/moderation/reports")).data.reports || []); } catch { /* not a moderator */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const resolve = async (r, action) => {
    try {
      await API.post(`/moderation/reports/${r.id}/resolve`, { action });
      toast.success(action === "remove" ? "Message removed" : "Report dismissed");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not resolve"); }
  };

  if (!reports.length) return null;
  return (
    <Card className="border border-rose-200" data-testid="moderation-queue">
      <CardContent className="p-4 space-y-3">
        <h2 className="text-sm font-semibold text-zinc-900 flex items-center gap-2">
          <Flag className="w-4 h-4 text-rose-600" /> Reported messages ({reports.length})
        </h2>
        {reports.map((r) => (
          <div key={r.id} className="border-t border-zinc-100 pt-3 flex items-start justify-between gap-3"
               data-testid={`moderation-report-${r.id}`}>
            <div className="text-sm min-w-0">
              <p className="text-zinc-900 break-words">"{r.message_text || "(photo)"}"</p>
              <p className="text-xs text-zinc-500">{r.sender_name} · {r.reason} · {new Date(r.created_at).toLocaleString()}</p>
            </div>
            <div className="flex gap-2 shrink-0">
              <Button size="sm" variant="outline" className="h-8 text-xs" onClick={() => resolve(r, "dismiss")}
                      data-testid={`moderation-dismiss-${r.id}`}>Dismiss</Button>
              <Button size="sm" className="h-8 text-xs bg-rose-600 hover:bg-rose-700 text-white"
                      onClick={() => resolve(r, "remove")} data-testid={`moderation-remove-${r.id}`}>Remove</Button>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
